import { PLAN_BUILDER_INTERNET_URL } from "@/lib/clickthrough-destination";
import type { BaseValuePropsSectionData } from "./types";

export const defaultSectionValuePropsData: BaseValuePropsSectionData = {
  elementName: "ValuePropsSection",
  title: {
    copy: "Internet plans include",
  },
  mobileLayout: "grid",
  cardStyle: "transparent",
  cards: [
    {
      title: {
        copy: "WiFi equipment & unlimited data",
      },
      media: {
        type: "image",
        image: "white-xfinity-router",
      },
      elementName: "ValuePropWifiEquipment",
    },
    {
      title: {
        copy: "Try internet for 30 days, risk-free",
      },
      media: {
        type: "image",
        image: "two-people-working-laptop-smartphone-outdoors",
      },
      elementName: "ValuePropUnlimitedMobile",
    },
    {
      title: {
        copy: "1 year of Mobile Select on us",
      },
      media: {
        type: "image",
        image: "woman-smiling-on-phone-call",
      },
      elementName: "ValuePropPeacockPremium",
    },
    {
      title: {
        copy: "24/7 support with the Xfinity app",
      },
      media: {
        type: "image",
        image: "person-laptop-orange-flowers",
      },
      elementName: "ValuePropSelfInstall",
    },
  ],
  ctaGroup: {
    alignment: "center",
    ctas: [
      {
        buttonWidth: {
          mobile: "full",
          tablet: "auto",
          desktop: "auto",
        },
        copy: "Shop plans",
        action: "link",
        url: PLAN_BUILDER_INTERNET_URL,
        modalKey: "",
      },
    ],
  },
  legal: {
    copy: "Requires Xfinity Internet 300 Mbps and above.",
  },
};
